import { render, staticRenderFns } from "./SharingInherited.vue?vue&type=template&id=05b67dc8&scoped=true&"
import script from "./SharingInherited.vue?vue&type=script&lang=js&"
export * from "./SharingInherited.vue?vue&type=script&lang=js&"
import style0 from "./SharingInherited.vue?vue&type=style&index=0&id=05b67dc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b67dc8",
  null
  
)

export default component.exports